import React from 'react';
import { defaultTemplate } from 'core/hoc';

function SliderCheckBoxTemplate({ t, field, onValueChange, disabled, customMessage }) {
	return (
		<div className='input--toggle__wrapper'>
			<label className="display--b">{t(field.label)}</label>
			<div>
				{customMessage &&
				<span className='input--toggle__label'>{customMessage} </span>}
				<input
					id={field.id}
					onClick={evt => (field.value = evt.currentTarget.checked)}
					onChange={
						onValueChange != null ? () => onValueChange(field.value) : evt => (field.value = evt.currentTarget.checked)
					}
					checked={field.value}
					className="input--toggle input--toggle--secondary"
					type="checkbox"
					value="1"
					readOnly={true}
					disabled={disabled}
				/>
				<label htmlFor={field.id}></label>
			</div>
		</div>
	);
}

export default defaultTemplate(SliderCheckBoxTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/components/SliderCheckBoxTemplate.jsx